import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "orderBy",
})
export class OrderByPipe implements PipeTransform {
  transform(array: any[], field: string, order: "asc" | "desc" = "asc"): any[] {
    if (!array || !field) return array;

    const sortedArray = array.sort((a, b) => {
      if (a[field] < b[field]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[field] > b[field]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });

    return sortedArray;
  }
}
